import React, { useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { time_Zones } from 'pages/B2B/constants';

type IProps = {
  selectedTimezone: string;
  handleChangeTimezone: (key: string, value: string) => void;
  disabled: boolean;
  keyName: string;
};

const TimeZoneSelector = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const allOptions = useMemo(() => time_Zones, []);

  const filteredOptions = useMemo(() => {
    if (!inputValue) return allOptions;
    return allOptions.filter((tz) =>
      tz.toLowerCase().includes(inputValue.toLowerCase())
    );
  }, [inputValue, allOptions]);

  return (
    <Autocomplete
      id="timezone-selector"
      options={filteredOptions}
      value={props.selectedTimezone || ''}
      onChange={(e, value) => {
        props.handleChangeTimezone(props.keyName, value || '');
      }}
      onInputChange={(e, value) => setInputValue(value)}
      disabled={props.disabled}
      isOptionEqualToValue={(option, value) => option === value}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          placeholder="Search timezone (e.g., Asia/Kolkata)"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default TimeZoneSelector;
